/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * GeoStrat API
 * Geopolitical strategy game simulation API - manage nations, diplomacy, trade, and military operations
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiError,
  RoleSerializerWithPermissions
} from '../models';

import { customInstance } from '.././custom-instance';
import type { ErrorType } from '.././custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * ViewSet for game roles and their associated permissions.
 *
 * Provides read-only access to role definitions including:
 * - Role metadata (name, description)
 * - Associated permissions for each role
 *
 * Roles are global (account_id=1) and define permission sets for users
 * in different positions (Prime Minister, Defense Minister, etc.).
 *
 * Security:
 * - Read-only access (GET only)
 * - Public access (AllowAny) as role definitions are not sensitive
 * - Actual user permissions are checked at the action level, not role level
 *
 * Performance:
 * - Prefetches 'permissions' to avoid N+1 queries when serializing
 * - Ordered by most recently created roles first
 */
export const rolesList = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RoleSerializerWithPermissions[]>(
      {url: `/all/roles/`, method: 'GET', signal
    },
      options);
    }




export const getRolesListQueryKey = () => {
    return [
    `/all/roles/`
    ] as const;
    }


export const getRolesListQueryOptions = <TData = Awaited<ReturnType<typeof rolesList>>, TError = ErrorType<ApiError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesList>>> = ({ signal }) => rolesList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesListQueryResult = NonNullable<Awaited<ReturnType<typeof rolesList>>>
export type RolesListQueryError = ErrorType<ApiError>


export function useRolesList<TData = Awaited<ReturnType<typeof rolesList>>, TError = ErrorType<ApiError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesList>>,
          TError,
          Awaited<ReturnType<typeof rolesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesList<TData = Awaited<ReturnType<typeof rolesList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesList>>,
          TError,
          Awaited<ReturnType<typeof rolesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesList<TData = Awaited<ReturnType<typeof rolesList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesList<TData = Awaited<ReturnType<typeof rolesList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * ViewSet for game roles and their associated permissions.
 *
 * Provides read-only access to role definitions including:
 * - Role metadata (name, description)
 * - Associated permissions for each role
 *
 * Roles are global (account_id=1) and define permission sets for users
 * in different positions (Prime Minister, Defense Minister, etc.).
 *
 * Security:
 * - Read-only access (GET only)
 * - Public access (AllowAny) as role definitions are not sensitive
 * - Actual user permissions are checked at the action level, not role level
 *
 * Performance:
 * - Prefetches 'permissions' to avoid N+1 queries when serializing
 * - Ordered by most recently created roles first
 */
export const rolesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RoleSerializerWithPermissions>(
      {url: `/all/roles/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getRolesRetrieveQueryKey = (id: number,) => {
    return [
    `/all/roles/${id}/`
    ] as const;
    }


export const getRolesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof rolesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesRetrieve>>> = ({ signal }) => rolesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof rolesRetrieve>>>
export type RolesRetrieveQueryError = ErrorType<ApiError>


export function useRolesRetrieve<TData = Awaited<ReturnType<typeof rolesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof rolesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRetrieve<TData = Awaited<ReturnType<typeof rolesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof rolesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesRetrieve<TData = Awaited<ReturnType<typeof rolesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRolesRetrieve<TData = Awaited<ReturnType<typeof rolesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






